/**
 * Created by Ivan on 02.06.2025
 */

const KingsCupLogic = function (mission) {
    cleverapps.EventEmitter.call(this);

    this.mission = mission;
    this.unlocked = mission.details && mission.details.unlocked;
    this.ready = mission.details && mission.details.ready;
};

KingsCupLogic.prototype = Object.create(cleverapps.EventEmitter.prototype);
KingsCupLogic.prototype.constructor = KingsCupLogic;

KingsCupLogic.prototype.getView = function () {
    if (this.unlocked) {
        return KingsCupWindow;
    }

    return KingsCupStartWindow;
};

KingsCupLogic.prototype.getFinishWindow = function () {
    return this.unlocked ? this.getView() : undefined;
};

KingsCupLogic.prototype.updateMissionData = function (value) {
    this.mission.update(value || 0, {
        unlocked: this.unlocked,
        ready: this.ready
    });
};

KingsCupLogic.prototype.getWelcomeRewards = function () {
    if (cleverapps.abExperiments.getGroup(ABExperiments.Tests.energyBoosterMissions) === "A") {
        return { energyBooster: "30 minutes" };
    }

    return RewardsConfig.KingsCupWelcomeBonus;
};

KingsCupLogic.prototype.startCompetition = function (callback) {
    callback = callback || (() => {});

    if (this.unlocked || !MissionManager.hasProperLocation(this.mission.type)) {
        callback();
        return;
    }

    this.unlocked = true;
    this.updateMissionData();

    if (cleverapps.config.type === "merge") {
        Map2dLocation.currentLocation.pixelsPlanner.restart();
    }

    this.mission.logEvent(Mission.EVENTS.MISSION_UNLOCKED);

    cleverapps.focusManager.display({
        focus: "KingsCupWelcome",
        stack: true,
        actions: [
            function (f) {
                setTimeout(f, 300);
            },

            (f) => {
                const rewards = new RewardsList(this.getWelcomeRewards(), {
                    event: this.mission.name,
                    fromRewardWindow: true,
                    withoutSidebar: cleverapps.resolution.isVertical()
                });

                new RewardWindow(rewards, {
                    title: Messages.get("KingsCupRewardWindow.Title")
                });

                cleverapps.focusManager.onceNoWindowsListener = () => {
                    cleverapps.focusManager.hideControlsWhileFocused(rewards.listControls());
                    f();
                };
            },

            (f) => {
                new GuideWindow(this.mission.guideWindow);
                cleverapps.focusManager.onceNoWindowsListener = f;
            },

            (f) => {
                const WindowCtor = this.getView();
                new WindowCtor(this.mission);
                cleverapps.focusManager.onceNoWindowsListener = () => {
                    f();
                    callback();
                };
            }
        ]
    });

    this.mission.updateCompetition(true);
    this.updateIcon();
};

KingsCupLogic.prototype.earnPoints = function (value) {
    if (!this.unlocked) {
        return;
    }

    this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, { value });
    this.mission.logEvent(Mission.EVENTS.MISSION_POINTS_DAU, { once: true });

    this.updateMissionData(value);

    this.trigger("updateResult", value);
};

KingsCupLogic.prototype.isUnlocked = function () {
    return this.unlocked;
};

KingsCupLogic.prototype.onUpdateMission = function (value) {
    if (value > 0 && typeof Game !== "undefined" && Game.currentGame) {
        this.pendingDelta = (this.pendingDelta || 0) + value;
    }
};

KingsCupLogic.prototype.receiveRewards = function (f) {
    const value = this.pendingDelta;
    delete this.pendingDelta;

    this.mission.receiveIncome(value, f);
};

KingsCupLogic.prototype.getCompetitionOptions = function () {
    return {
        ...Missions[Mission.TYPE_KINGSCUP].competition,
        start: Date.now(),
        duration: this.mission.getTimeLeft() 
    };
};

KingsCupLogic.prototype.updateIcon = function () {
    this.mission.updateMissionIcon();
    this.trigger("updateStatus");
};

KingsCupLogic.prototype.setReady = function (ready) {
    this.ready = ready;
    this.updateMissionData();
};

KingsCupLogic.prototype.isAttentionRequired = function () {
    if (this.mission.runningCompetition && this.mission.runningCompetition.hasPlaceChanged()) {
        return true;
    }

    return !this.isUnlocked() && this.ready;
};

KingsCupLogic.prototype.calcStatusInfo = function () {
    let text = "", sidebarTitle, animation, disabled = false;

    if (!this.isUnlocked()) {
        if (this.ready) {
            text = sidebarTitle = Messages.get("SideBarPlace.Start");
        } else {
            text = sidebarTitle = Messages.get("KingsCup.inactive");
            animation = "inactive";
            disabled = true;
        }
    } else {
        text = `%% ${this.mission.result}`;
    }

    return {
        text,
        sidebarTitle,
        icons: {
            "%%": this.mission.getIcon()
        },
        animation,
        disabled
    };
};

KingsCupLogic.ROW_VIEWS = {};
